import { useSyncExternalStore } from 'react';
import { Menu, Slider, Tooltip, UnstyledButton } from '@mantine/core';
import { useI18n } from '../../i18n';
import { getZoom, setZoom, subscribeSettings, ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from '../../settings';
import classes from './layout.module.css';

const PRESETS = [50, 75, 100, 125, 150, 200];

/** Масштаб таблиц, как в Excel: − / + с шагом 5 %, ползунок и готовые значения. Запоминается для пользователя. */
export function ZoomControl() {
  const { t } = useI18n();
  const zoom = useSyncExternalStore(subscribeSettings, getZoom);
  return (
    <div className={classes.zoom}>
      <Tooltip label={t('Уменьшить таблицу')}>
        <UnstyledButton
          className={classes.zoomBtn}
          onClick={() => setZoom(zoom - ZOOM_STEP)}
          disabled={zoom <= ZOOM_MIN}
          aria-label={t('Уменьшить таблицу')}
        >
          −
        </UnstyledButton>
      </Tooltip>
      <Menu position="bottom" width={240} closeOnItemClick>
        <Menu.Target>
          <Tooltip label={t('Масштаб таблиц (Ctrl + колёсико над таблицей)')}>
            <UnstyledButton className={classes.zoomValue}>{zoom}%</UnstyledButton>
          </Tooltip>
        </Menu.Target>
        <Menu.Dropdown>
          <div className={classes.zoomSlider}>
            <Slider
              min={ZOOM_MIN}
              max={ZOOM_MAX}
              step={ZOOM_STEP}
              value={zoom}
              onChange={setZoom}
              label={(v) => `${v}%`}
              marks={[{ value: 100 }]}
            />
          </div>
          <Menu.Divider />
          {PRESETS.map((p) => (
            <Menu.Item key={p} onClick={() => setZoom(p)} rightSection={p === zoom ? '✓' : null}>
              {p === 100 ? t('{n}% — обычный', { n: p }) : `${p}%`}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
      <Tooltip label={t('Увеличить таблицу')}>
        <UnstyledButton
          className={classes.zoomBtn}
          onClick={() => setZoom(zoom + ZOOM_STEP)}
          disabled={zoom >= ZOOM_MAX}
          aria-label={t('Увеличить таблицу')}
        >
          +
        </UnstyledButton>
      </Tooltip>
    </div>
  );
}
